import { TableRowSelection } from "antd/lib/table/interface";
import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";
import _isObject from "lodash/isObject";
import { RequestHistory, RequestHistoryFilter } from "models/RequestHistory";
import React, { Reducer } from "react";
import { IdFilter } from "react3l-advanced-filters";
import { Model, ModelFilter, OrderType } from "react3l-common";
import { Observable, forkJoin } from "rxjs";
import { utilService } from "services/common-services/util-service";
import { queryStringService } from "services/page-services/query-string-service";
import { FilterAction, FilterActionEnum } from "./filter-service";
import { KeyType } from "./list-service";

export enum CompareState {
  GREEN,
  RED,
  WHITE,
}

export enum HISTORY_STATE_TYPE {
  CHECK = "check",
  ADD = "add",
  REMOVE = "remove",
}

/* Start action and reducer of Request History */
type RequestHistoryState<T extends Model> = {
  requestHistoryList?: T[];
  requestHistoryCount?: number;
  selectedRowKeys?: KeyType[];
  selectedRows?: T[];
};

enum RequestHistoryEnum {
  UPDATE_REQUEST_HISTORY,
  UPDATE_SELECTED_ROW_KEYS,
  UPDATE_ALL,
}

interface RequestHistoryAction<T extends Model> {
  type: RequestHistoryEnum;
  payload?: RequestHistoryState<T>;
}

function requestHistoryReducer<T extends Model>(
  state: RequestHistoryState<T>,
  action: RequestHistoryAction<T>
): RequestHistoryState<T> {
  switch (action.type) {
    case RequestHistoryEnum.UPDATE_ALL:
      return {
        ...state,
        requestHistoryList: [...action.payload.requestHistoryList],
        selectedRowKeys: [...action.payload.selectedRowKeys],
        selectedRows: [...action.payload.selectedRows],
      };
    case RequestHistoryEnum.UPDATE_REQUEST_HISTORY:
      return {
        ...state,
        requestHistoryList: [...action.payload.requestHistoryList],
        requestHistoryCount: action.payload.requestHistoryCount,
      };
    case RequestHistoryEnum.UPDATE_SELECTED_ROW_KEYS:
      return {
        ...state,
        selectedRowKeys: [...action.payload.selectedRowKeys],
      };
    default:
      return { ...state };
  }
}

/* End action and reducer of Request History */

export const requestHistoryService = {
  /**
   * react hook for compare 2 content of Request History;
   * @param: fieldValue: string
   * @param: contentFrom?: any
   * @param: contentTo?: any
   * @return: CompareState
   **/
  useCompareHistoryRequest(
    fieldValue: string,
    contentFrom: any,
    contentTo: any
  ): CompareState {
    if (contentFrom && contentTo) {
      if (contentFrom[fieldValue]) {
        const value = _isObject(contentFrom[fieldValue])
          ? contentFrom[fieldValue]["id"]
          : contentFrom[fieldValue];

        const oldValue = _isObject(contentTo[fieldValue])
          ? contentTo[fieldValue]["id"]
          : contentTo[fieldValue];

        if (
          (value !== null || value !== undefined) &&
          (oldValue !== null || oldValue !== undefined)
        ) {
          if (!_isEqual(value, oldValue)) {
            return CompareState.RED;
          }
        }
        if (!value && oldValue) {
          return CompareState.RED;
        }
        if (value && !oldValue) {
          return CompareState.GREEN;
        }

        const arrrValue =
          contentFrom[fieldValue]?.length > 0
            ? contentFrom[fieldValue].map((item: any) => item.id)
            : [];

        const arrOldValue =
          contentTo[fieldValue]?.length > 0
            ? contentTo[fieldValue].map((item: any) => item.id)
            : [];

        if (arrrValue?.length > 0 && arrOldValue?.length > 0) {
          if (!_isEqual(arrrValue, arrOldValue)) {
            return CompareState.RED;
          }
        }
        if (arrrValue?.length === 0 && arrOldValue?.length > 0) {
          return CompareState.RED;
        }
        if (arrrValue?.length > 0 && arrOldValue?.length === 0) {
          return CompareState.GREEN;
        }
      }
    } else if (contentTo) {
      return CompareState.RED;
    } else if (contentFrom) {
      return CompareState.GREEN;
    }
    return CompareState.WHITE;
  },

  /**
   * react hook for control table list request history;
   * @param: listRequestHistory: (filter: TFilter) => Observable<T[]>
   * @param: modelFilter?: TFilter
   * @param: rowKey: string = "id"
   * @return: {
      loadingCompare,
      content,
      oldContent,
      requestHistories,
      getRowContent,
      getContents,
   * }
   **/
  // useHistoryRequestList<T extends Model, TFilter extends ModelFilter>(
  //   listRequestHistory: (filter: TFilter) => Observable<T[]>,
  //   modelFilter: TFilter,
  //   redirectPath: string,
  //   rowKey: string = "id",
  //   tabKey?: string
  // ) {
  //   const [
  //     { requesHistoryList, selectedRowKeys, selectedRows },
  //     dispatchHistoryState,
  //   ] = React.useReducer<
  //     Reducer<RequestHistoryState<T>, RequestHistoryAction<T>>
  //   >(requestHistoryReducer, {
  //     requesHistoryList: [],
  //     selectedRowKeys: [],
  //     selectedRows: [],
  //   });

  //   const { requestId, history } =
  //     queryStringService.useGetQueryString("requestId");

  //   const [loadingRequestHistory, setLoadingRequestHistory] =
  //     React.useState<boolean>(false);
  //   const handleChangeCheckBox = React.useCallback(
  //     (selectedRowKeys: KeyType[], selectedRows: T[]) => {
  //       const listValue = _cloneDeep(requesHistoryList);
  //       var modifiedList: T[];
  //       if (selectedRowKeys.length < 2) {
  //         modifiedList = listValue.map((current: T) => {
  //           const currentValue = { ...current } as T & { disabled: boolean };
  //           currentValue.disabled = false;
  //           return currentValue;
  //         });
  //       } else {
  //         modifiedList = listValue.map((current: T) => {
  //           const currentValue = { ...current } as T & { disabled: boolean };
  //           if (selectedRowKeys.includes(currentValue[rowKey])) {
  //             currentValue.disabled = false;
  //           } else {
  //             currentValue.disabled = true;
  //           }
  //           return currentValue;
  //         });
  //       }
  //       dispatchHistoryState({
  //         type: RequestHistoryEnum.UPDATE_ALL,
  //         payload: {
  //           requesHistoryList: modifiedList,
  //           selectedRowKeys: selectedRowKeys,
  //           selectedRows,
  //         },
  //       });
  //     },
  //     [requesHistoryList, rowKey]
  //   );

  //   const rowSelection: TableRowSelection<any> = React.useMemo(() => {
  //     return {
  //       onChange: handleChangeCheckBox,
  //       hideSelectAll: true,
  //       selectedRowKeys,
  //       getCheckboxProps: (record: T & { disabled: boolean }) => ({
  //         disabled: record.disabled,
  //       }),
  //     };
  //   }, [handleChangeCheckBox, selectedRowKeys]);

  //   const handleCompareHistory = React.useCallback(() => {
  //     const selectedRowKeyValues = [...selectedRowKeys];
  //     if (tabKey) {
  //       history.push({
  //         pathname: redirectPath,
  //         search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}&&tabKey=${tabKey}`,
  //       });
  //     } else {
  //       history.push({
  //         pathname: redirectPath,
  //         search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}`,
  //       });
  //     }
  //   }, [history, redirectPath, selectedRowKeys, tabKey]);

  //   React.useEffect(() => {
  //     const filterValue = { ...modelFilter } as TFilter & {
  //       requestId: IdFilter;
  //     };
  //     filterValue.requestId = { ...new IdFilter(), equal: requestId };
  //     setLoadingRequestHistory(true);
  //     const subcription = listRequestHistory(filterValue)
  //       .pipe(
  //         finalize(() => {
  //           setLoadingRequestHistory(false);
  //         })
  //       )
  //       .subscribe({
  //         next: (res) => {
  //           if (res) {
  //             dispatchHistoryState({
  //               type: RequestHistoryEnum.UPDATE_REQUEST_HISTORY_LIST,
  //               payload: {
  //                 requesHistoryList: res,
  //               },
  //             });
  //           }
  //         },
  //         error: (err) => {},
  //       });

  //     return () => {
  //       subcription.unsubscribe();
  //     };
  //   }, [listRequestHistory, modelFilter, requestId]);

  //   return {
  //     requesHistoryList,
  //     selectedRows,
  //     selectedRowKeys,
  //     loadingRequestHistory,
  //     rowSelection,
  //     handleCompareHistory,
  //   };
  // },
  // useHistoryRequestList<T extends Model, TFilter extends ModelFilter>(
  //   listRequestHistory: (filter: TFilter) => Observable<T[]>,
  //   countRequestHistory: (filter: TFilter) => Observable<number>,
  //   modelFilter: TFilter,
  //   dispatch: React.Dispatch<FilterAction<ModelFilter>>,
  //   redirectPath: string,
  //   rowKey: string = "id",
  //   tabKey: string
  // ) {
  //   const firstLoad = React.useRef(true);

  //   const [
  //     {
  //       requestHistoryList,
  //       requestHistoryCount,
  //       selectedRowKeys,
  //       selectedRows,
  //     },
  //     dispatchHistoryState,
  //   ] = React.useReducer<
  //     Reducer<RequestHistoryState<T>, RequestHistoryAction<T>>
  //   >(requestHistoryReducer, {
  //     requestHistoryList: [],
  //     requestHistoryCount: 0,
  //     selectedRowKeys: [],
  //     selectedRows: [],
  //   });

  //   const { requestId, history } =
  //     queryStringService.useGetQueryString("requestId");

  //   // const [loadingRequestHistory, setLoadingRequestHistory] =
  //   //   React.useState<boolean>(false);
  //   const { showSpinning, hideSpinning } = webService.useSpinning();

  //   const handleModifiedList = React.useCallback(
  //     (listValue: T[], selectedRowKey: KeyType[]) => {
  //       var modifiedList: T[];
  //       if (selectedRowKey.length < 2) {
  //         modifiedList = listValue.map((current: T) => {
  //           const currentValue = { ...current } as T & {
  //             disabled: boolean;
  //           };
  //           currentValue.disabled = false;
  //           return currentValue;
  //         });
  //       } else {
  //         modifiedList = listValue.map((current: T) => {
  //           const currentValue = { ...current } as T & {
  //             disabled: boolean;
  //           };
  //           if (selectedRowKey.includes(currentValue[rowKey])) {
  //             currentValue.disabled = false;
  //           } else {
  //             currentValue.disabled = true;
  //           }
  //           return currentValue;
  //         });
  //       }
  //       return modifiedList;
  //     },
  //     [rowKey]
  //   );

  //   const handleLoadList = React.useCallback(
  //     (filter: TFilter) => {
  //       const filterValue = { ...filter } as TFilter & {
  //         requestId: IdFilter;
  //       };
  //       filterValue.requestId = { ...new IdFilter(), equal: requestId };
  //       dispatch({
  //         type: FilterActionEnum.SET,
  //         payload: filterValue,
  //       });
  //       showSpinning();
  //       const subcription = forkJoin([
  //         listRequestHistory(filterValue),
  //         countRequestHistory(filterValue),
  //       ])
  //         .pipe(
  //           finalize(() => {
  //             hideSpinning();
  //           })
  //         )
  //         .subscribe({
  //           next: (res) => {
  //             if (res) {
  //               const listValue = _cloneDeep(res[0]);
  //               var modifiedList = handleModifiedList(
  //                 listValue,
  //                 selectedRowKeys
  //               );
  //               dispatchHistoryState({
  //                 type: RequestHistoryEnum.UPDATE_REQUEST_HISTORY,
  //                 payload: {
  //                   requestHistoryList: modifiedList,
  //                   requestHistoryCount: res[1],
  //                 },
  //               });
  //             }
  //           },
  //           error: (err) => {},
  //         });

  //       return () => {
  //         subcription.unsubscribe();
  //       };
  //     },
  //     [
  //       countRequestHistory,
  //       dispatch,
  //       handleModifiedList,
  //       hideSpinning,
  //       listRequestHistory,
  //       requestId,
  //       selectedRowKeys,
  //       showSpinning,
  //     ]
  //   );

  //   const handleChangeCheckBox = React.useCallback(
  //     (record: any, selected: boolean) => {
  //       let selectedRowKeyValues =
  //         selectedRowKeys?.length > 0 ? [...selectedRowKeys] : [];
  //       let selectedRowValues =
  //         selectedRows?.length > 0 ? [...selectedRows] : [];
  //       const { versionId } = record;

  //       if (selected) {
  //         selectedRowKeyValues = [...selectedRowKeyValues, versionId];
  //         selectedRowValues = [...selectedRowValues, record];
  //       } else {
  //         selectedRowKeyValues = selectedRowKeyValues.filter(
  //           (current: any) => current !== versionId
  //         );
  //         selectedRowValues = selectedRowValues.filter(
  //           (current: any) => current.versionId !== record.versionId
  //         );
  //       }

  //       const listValue = _cloneDeep(requestHistoryList);
  //       var modifiedList = handleModifiedList(listValue, selectedRowKeyValues);

  //       dispatchHistoryState({
  //         type: RequestHistoryEnum.UPDATE_ALL,
  //         payload: {
  //           requestHistoryList: modifiedList,
  //           selectedRowKeys: selectedRowKeyValues,
  //           selectedRows: selectedRowValues,
  //         },
  //       });
  //     },
  //     [handleModifiedList, requestHistoryList, selectedRowKeys, selectedRows]
  //   );

  //   const handlePagination = React.useCallback(
  //     (skip: number, take: number) => {
  //       const filterValue = { ...modelFilter, skip, take };
  //       handleLoadList(filterValue);
  //     },
  //     [modelFilter, handleLoadList]
  //   );

  //   const rowSelection: TableRowSelection<any> = React.useMemo(() => {
  //     return {
  //       onSelect(record: any, selected: boolean) {
  //         handleChangeCheckBox(record, selected);
  //       },
  //       hideSelectAll: true,
  //       selectedRowKeys,
  //       getCheckboxProps: (record: T & { disabled: boolean }) => ({
  //         disabled: record.disabled,
  //       }),
  //     };
  //   }, [handleChangeCheckBox, selectedRowKeys]);

  //   // const handleCompareHistory = React.useCallback(() => {
  //   //   const selectedRowKeyValues = [...selectedRowKeys];
  //   //   history.push({
  //   //     pathname: redirectPath,
  //   //     search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}`,
  //   //   });
  //   // }, [history, redirectPath, selectedRowKeys]);

  //   const handleCompareHistory = React.useCallback(() => {
  //     const selectedRowKeyValues = [...selectedRowKeys];
  //     if (tabKey) {
  //       history.push({
  //         pathname: redirectPath,
  //         search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}&&tabKey=${tabKey}`,
  //       });
  //     } else {
  //       history.push({
  //         pathname: redirectPath,
  //         search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}`,
  //       });
  //     }
  //   }, [history, redirectPath, selectedRowKeys, tabKey]);

  //   React.useEffect(() => {
  //     if (firstLoad.current) {
  //       handleLoadList(modelFilter);
  //       firstLoad.current = false;
  //     }
  //   }, [handleLoadList, modelFilter]);

  //   return {
  //     requestHistoryList,
  //     requestHistoryCount,
  //     selectedRows,
  //     rowSelection,
  //     handleCompareHistory,
  //     handlePagination,
  //     // showSpinning
  //   };
  // },

  useHistoryRequestList<T extends Model, TFilter extends ModelFilter>(
    listRequestHistory: (filter: TFilter) => Observable<T[]>,
    countRequestHistory: (filter: TFilter) => Observable<number>,
    modelFilter: TFilter,
    dispatch: React.Dispatch<FilterAction<ModelFilter>>,
    redirectPath: string,
    rowKey: string = "id",
    tabKey?: string
  ) {
    const firstLoad = React.useRef(true);

    const [
      {
        requestHistoryList,
        requestHistoryCount,
        selectedRowKeys,
        selectedRows,
      },
      dispatchHistoryState,
    ] = React.useReducer<
      Reducer<RequestHistoryState<T>, RequestHistoryAction<T>>
    >(requestHistoryReducer, {
      requestHistoryList: [],
      requestHistoryCount: 0,
      selectedRowKeys: [],
      selectedRows: [],
    });

    const { requestId, history } =
      queryStringService.useGetQueryString("requestId");

    // const { showSpinning, hideSpinning } = webService.useSpinning();

    const handleModifiedList = React.useCallback(
      (listValue: T[], selectedRowKey: KeyType[]) => {
        var modifiedList: T[];
        if (selectedRowKey.length < 2) {
          modifiedList = listValue.map((current: T) => {
            const currentValue = { ...current } as T & {
              disabled: boolean;
            };
            currentValue.disabled = false;
            return currentValue;
          });
        } else {
          modifiedList = listValue.map((current: T) => {
            const currentValue = { ...current } as T & {
              disabled: boolean;
            };
            if (selectedRowKey.includes(currentValue[rowKey])) {
              currentValue.disabled = false;
            } else {
              currentValue.disabled = true;
            }
            return currentValue;
          });
        }
        return modifiedList;
      },
      [rowKey]
    );

    const handleLoadList = React.useCallback(
      (filter: TFilter) => {
        const filterValue = { ...filter } as TFilter & {
          requestId: IdFilter;
        };
        filterValue.requestId = { ...new IdFilter(), equal: requestId };
        dispatch({
          type: FilterActionEnum.SET,
          payload: filterValue,
        });
        // showSpinning();
        const subcription = forkJoin([
          listRequestHistory(filterValue),
          countRequestHistory(filterValue),
        ])
          // .pipe(
          //   finalize(() => {
          //     hideSpinning();
          //   })
          // )
          .subscribe({
            next: (res) => {
              if (res) {
                const listValue = _cloneDeep(res[0]);
                var modifiedList = handleModifiedList(
                  listValue,
                  selectedRowKeys
                );
                dispatchHistoryState({
                  type: RequestHistoryEnum.UPDATE_REQUEST_HISTORY,
                  payload: {
                    requestHistoryList: modifiedList,
                    requestHistoryCount: res[1],
                  },
                });
              }
            },
            error: (err) => {},
          });

        return () => {
          subcription.unsubscribe();
        };
      },
      [
        countRequestHistory,
        dispatch,
        handleModifiedList,
        // hideSpinning,
        listRequestHistory,
        requestId,
        selectedRowKeys,
        // showSpinning,
      ]
    );

    const handleChangeCheckBox = React.useCallback(
      (record: any, selected: boolean) => {
        let selectedRowKeyValues =
          selectedRowKeys?.length > 0 ? [...selectedRowKeys] : [];
        let selectedRowValues =
          selectedRows?.length > 0 ? [...selectedRows] : [];
        const { versionId } = record;

        if (selected) {
          selectedRowKeyValues = [...selectedRowKeyValues, versionId];
          selectedRowValues = [...selectedRowValues, record];
        } else {
          selectedRowKeyValues = selectedRowKeyValues.filter(
            (current: any) => current !== versionId
          );
          selectedRowValues = selectedRowValues.filter(
            (current: any) => current.versionId !== record.versionId
          );
        }

        const listValue = _cloneDeep(requestHistoryList);
        var modifiedList = handleModifiedList(listValue, selectedRowKeyValues);

        dispatchHistoryState({
          type: RequestHistoryEnum.UPDATE_ALL,
          payload: {
            requestHistoryList: modifiedList,
            selectedRowKeys: selectedRowKeyValues,
            selectedRows: selectedRowValues,
          },
        });
      },
      [handleModifiedList, requestHistoryList, selectedRowKeys, selectedRows]
    );

    const handlePagination = React.useCallback(
      (skip: number, take: number) => {
        const filterValue = { ...modelFilter, skip, take };
        handleLoadList(filterValue);
      },
      [modelFilter, handleLoadList]
    );

    const rowSelection: TableRowSelection<any> = React.useMemo(() => {
      return {
        onSelect(record: any, selected: boolean) {
          handleChangeCheckBox(record, selected);
        },
        hideSelectAll: true,
        selectedRowKeys,
        getCheckboxProps: (record: T & { disabled: boolean }) => ({
          disabled: record.disabled,
        }),
      };
    }, [handleChangeCheckBox, selectedRowKeys]);

    // const handleCompareHistory = React.useCallback(() => {
    //   const selectedRowKeyValues = [...selectedRowKeys];
    //   history.push({
    //     pathname: redirectPath,
    //     search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}`,
    //   });
    // }, [history, redirectPath, selectedRowKeys]);

    const handleCompareHistory = React.useCallback(() => {
      const selectedRowKeyValues = [...selectedRowKeys];
      let newSearch = history?.location?.search?.replace("?", "");
      if (tabKey) {
        history.push({
          pathname: redirectPath,
          search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}&&${newSearch}`,
        });
      } else {
        history.push({
          pathname: redirectPath,
          search: `?versionTo=${selectedRowKeyValues[0]}&versionFrom=${selectedRowKeyValues[1]}`,
        });
      }
    }, [history, redirectPath, selectedRowKeys, tabKey]);

    React.useEffect(() => {
      if (firstLoad.current) {
        handleLoadList(modelFilter);
        firstLoad.current = false;
      }
    }, [handleLoadList, modelFilter]);

    return {
      requestHistoryList,
      requestHistoryCount,
      selectedRows,
      rowSelection,
      handleCompareHistory,
      handlePagination,
    };
  },

  /**
   * react hook for control detail view of 2 request history;
   * @param: requestHistoryRepository: (filter: TFilter) => Observable<T[]>
   * @return: {
      loadingCompare,
      content,
      oldContent,
      requestHistories,
      getRowContent,
      getContents,
      getPrimitiveArrays,
      getPrimitiveValue
   * }
   **/
  useHistoryRequestDetail(
    requestHistoryRepository: (
      filter: RequestHistoryFilter
    ) => Observable<RequestHistory[]>
  ) {
    const { queryObject } = queryStringService.useGetQueryString();

    const versionFrom = React.useMemo<number>(() => {
      const versionFrom = queryObject["versionFrom"]
        ? Number(queryObject["versionFrom"])
        : 0;
      return versionFrom;
    }, [queryObject]);

    const versionTo = React.useMemo<number>(() => {
      const versionTo = queryObject["versionTo"]
        ? Number(queryObject["versionTo"])
        : 0;
      return versionTo;
    }, [queryObject]);

    // const { showSpinning, hideSpinning } = webService.useSpinning();

    const [requestHistories, setRequestHistories] = React.useState<
      RequestHistory[]
    >([]);

    const [content, setContent] = React.useState(new RequestHistory());

    const [oldContent, setOldContent] = React.useState(new RequestHistory());

    const getPrimitiveArrays = React.useCallback(
      (arrayFieldName: string) => {
        const primitiveList =
          content[arrayFieldName] && content[arrayFieldName].length > 0
            ? [...content[arrayFieldName]]
            : [];
        const primitiveOldList =
          oldContent[arrayFieldName] && oldContent[arrayFieldName].length > 0
            ? [...oldContent[arrayFieldName]]
            : [];
        const concatList = [...primitiveList, ...primitiveOldList];
        const uniqueList = concatList.filter((v, i, a) => a.indexOf(v) === i);
        return uniqueList;
      },
      [content, oldContent]
    );

    const getPrimitiveValue = React.useCallback(
      (arrayFieldName: string, value: string | number) => {
        const requestArrays =
          content[arrayFieldName] && content[arrayFieldName].length > 0
            ? content[arrayFieldName]
            : [];
        const oldRequestArrays =
          oldContent[arrayFieldName] && oldContent[arrayFieldName].length > 0
            ? oldContent[arrayFieldName]
            : [];
        const oldItem = requestArrays.filter(
          (current: number | string) => current === value
        )[0];
        const item = oldRequestArrays.filter(
          (current: number | string) => current === value
        )[0];
        var state: HISTORY_STATE_TYPE;
        if (oldItem && item) {
          state = HISTORY_STATE_TYPE.CHECK;
        } else {
          if (item) {
            state = HISTORY_STATE_TYPE.ADD;
          }
          if (oldItem) {
            state = HISTORY_STATE_TYPE.REMOVE;
          }
        }
        return {
          content: {
            content: item,
          },
          oldContent: {
            content: oldItem,
          },
          state,
        };
      },
      [content, oldContent]
    );

    const getContents = React.useCallback(
      <T extends Model>(contentField: string, uniqueField?: string) => {
        const list: T[] =
          content[contentField] && content[contentField].length > 0
            ? [...content[contentField]]
            : [];
        const oldList: T[] =
          oldContent[contentField] && oldContent[contentField].length > 0
            ? [...oldContent[contentField]]
            : [];
        const concatList = [...oldList, ...list];
        const contents = utilService.uniqueArray(concatList, uniqueField);
        contents.sort((a: any, b: any) => {
          return a[contentField] - b[contentField];
        });
        return contents;
      },
      [content, oldContent]
    );

    const getRowContent = React.useCallback(
      <T extends Model>(contentField: string, index?: number) =>
        (uniqueValue: string | number, uniqueField: string = "rowId") => {
          const requestContents =
            content[contentField] && content[contentField].length > 0
              ? content[contentField]
              : [];
          const oldRequestContents =
            oldContent[contentField] && oldContent[contentField].length > 0
              ? oldContent[contentField]
              : [];

          const oldContentValue = oldRequestContents.filter(
            (current: T) => current[uniqueField] === uniqueValue
          )[0];
          const contentValue = requestContents.filter(
            (current: T) => current[uniqueField] === uniqueValue
          )[0];
          var state: HISTORY_STATE_TYPE;

          if (contentValue && oldContentValue) {
            //

            state = HISTORY_STATE_TYPE.CHECK;
          } else {
            // state = HISTORY_STATE_TYPE.ADD;
            if (contentValue) {
              //
              state = HISTORY_STATE_TYPE.ADD;
            }
            if (oldContentValue) {
              //
              state = HISTORY_STATE_TYPE.REMOVE;
            }
          }
          return {
            content: contentValue,
            oldContent: oldContentValue,
            state,
          };
        },
      [oldContent, content]
    );

    React.useEffect(() => {
      const requestHistoryFilter = new RequestHistoryFilter();
      requestHistoryFilter.versionId.in = [versionFrom, versionTo];
      requestHistoryFilter.orderBy = "savedAt";
      requestHistoryFilter.orderType = OrderType.DESC;

      // showSpinning();
      const subcription = requestHistoryRepository(requestHistoryFilter)
        // .pipe(
        //   finalize(() => {
        //     hideSpinning();
        //   })
        // )
        .subscribe({
          next: (res) => {
            if (res && res.length === 2) {
              setRequestHistories(res);
              setOldContent(res[0].content);
              setContent(res[1].content);
            }
          },
        });
      return () => {
        subcription.unsubscribe();
      };
    }, [
      // hideSpinning,
      requestHistoryRepository,
      // showSpinning,
      versionFrom,
      versionTo,
    ]);

    return {
      content,
      oldContent,
      requestHistories,
      getRowContent,
      getContents,
      getPrimitiveArrays,
      getPrimitiveValue,
      // showSpinning,
    };
  },
};
